var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 10.6 10.6",
    style: {
      enableBackground: "new 0 0 10.6 10.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#242E38;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,10.6V3.1c0-0.4,0.3-0.7,0.7-0.7h1.6V0.7C2.3,0.3,2.7,0,3.1,0h4.4c0.4,0,0.7,0.3,0.7,0.7v4h1.6 c0.4,0,0.7,0.3,0.7,0.7v5.1H6V8.1H4.5v2.5H0z M1,9.5h1.4V8.1H1V9.5z M1,7.2h1.4V5.8H1V7.2z M1,4.8h1.4V3.4H1V4.8z M3.4,7.2h1.4V5.8 H3.4V7.2z M3.4,4.8h1.4V3.4H3.4V4.8z M3.4,2.5h1.4V1H3.4V2.5z M5.7,7.2h1.4V5.8H5.7V7.2z M5.7,4.8h1.4V3.4H5.7V4.8z M5.7,2.5h1.4V1 H5.7V2.5z M8.1,9.5h1.4V8.1H8.1V9.5z M8.1,7.2h1.4V5.8H8.1V7.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/Company.96e1a6d1b6c580053c5f4c9772a9648f.svg";
export { ForwardRef as ReactComponent };